exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tct-accordions{display:block;width:100%}.tct-accordions{width:100%}.tct-accordions__title{font-size:18px;text-align:center;margin-bottom:5px}.tct-accordions__container>*{margin-bottom:10px}.tct-accordions__empty{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:10px}.tct-accordions__empty span{display:block;text-align:center;width:100%}@media print{.tct-accordions__title{font-size:1.125em}}", ""]);

// exports
